var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueesdetoxMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 247.597,
    height: 45.66,
    viewBox: "0 0 247.597 45.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b{fill:#6a841e;}.c{filter:url(#w);}.d{filter:url(#u);}.e{filter:url(#s);}.f{filter:url(#q);}.g{filter:url(#o);}.h{filter:url(#m);}.i{filter:url(#k);}.j{filter:url(#i);}.k{filter:url(#g);}.l{filter:url(#e);}.m{filter:url(#c);}.n{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 8.778,
    width: 29.499,
    height: 36.883,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 13.615,
    y: 5.964,
    width: 35.767,
    height: 39.185,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 34.242,
    y: 6.208,
    width: 32.453,
    height: 35.545,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 52.159,
    y: 0.522,
    width: 30.534,
    height: 40.952,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    x: 74.762,
    y: 6.208,
    width: 30.534,
    height: 35.266,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "j"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "j"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 89.261,
    y: 5.906,
    width: 31.243,
    height: 35.79,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    x: 111.643,
    y: 2.622,
    width: 36.86,
    height: 39.525,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "n"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "n"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    x: 134.283,
    y: 2.636,
    width: 33.992,
    height: 39.511,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "p"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "p"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    x: 152.665,
    y: 2.636,
    width: 34.963,
    height: 39.511,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "r"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "r"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    x: 170.829,
    y: 2.318,
    width: 40.163,
    height: 40.148,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "t"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "t"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "u",
    x: 193.181,
    y: 2.622,
    width: 38.311,
    height: 39.525,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "v"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "v"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "w",
    x: 215.039,
    y: 0,
    width: 32.558,
    height: 42.147,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "x"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "x"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-521.264 -417.075)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(530.264 423.597)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "n",
    transform: "matrix(1, 0, 0, 1, -9, -6.52)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M534.5,450.28a2.666,2.666,0,0,1,.035-.476.67.67,0,0,1,.116-.291.388.388,0,0,1,.215-.14,1.355,1.355,0,0,1,.331-.035h1.965a.494.494,0,0,1,.4.174.6.6,0,0,1,.146.4q0,1.023-.029,1.773a3.286,3.286,0,0,1-.227,1.192,3.337,3.337,0,0,1-.7.936,7.668,7.668,0,0,1-.884.709q-.465.32-.93.6a5.365,5.365,0,0,0-.837.628,2.889,2.889,0,0,0-.6.785,2.268,2.268,0,0,0-.233,1.069,2.317,2.317,0,0,0,.215.994,2.552,2.552,0,0,0,.587.8,2.824,2.824,0,0,0,1.918.739,2.252,2.252,0,0,0,.953-.2,2.709,2.709,0,0,0,.756-.512,2.872,2.872,0,0,0,.54-.715,3.2,3.2,0,0,0,.308-.82,1.984,1.984,0,0,1,.378-.75.93.93,0,0,1,.7-.343h1.616a.46.46,0,0,1,.4.145.693.693,0,0,1,.128.308v.337a5.29,5.29,0,0,1-.483,2.208,5.438,5.438,0,0,1-1.261,1.734,5.792,5.792,0,0,1-1.837,1.129,6.031,6.031,0,0,1-2.2.405,6.1,6.1,0,0,1-2.185-.394,5.8,5.8,0,0,1-1.82-1.095,5.26,5.26,0,0,1-1.25-1.676,4.874,4.874,0,0,1-.465-2.127,5.4,5.4,0,0,1,.314-1.971,4.732,4.732,0,0,1,.785-1.348,5.292,5.292,0,0,1,1.018-.93q.546-.378,1.017-.721a4.331,4.331,0,0,0,.785-.721,1.4,1.4,0,0,0,.314-.925Zm3.151-3.849a1.591,1.591,0,0,1-.087.558.4.4,0,0,1-.424.233H535.31c-.093,0-.188,0-.285-.012a.84.84,0,0,1-.267-.064.529.529,0,0,1-.2-.151.437.437,0,0,1-.081-.285v-1.721c0-.109,0-.209.012-.3a.775.775,0,0,1,.064-.256.4.4,0,0,1,.157-.18.559.559,0,0,1,.291-.064h1.826a1.668,1.668,0,0,1,.616.087q.209.087.209.436Z",
    transform: "translate(-521.26 -429.41)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "m",
    transform: "matrix(1, 0, 0, 1, -9, -6.52)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M564.222,446.064a8.848,8.848,0,0,1,1.209-4.488,9.1,9.1,0,0,1,1.39-1.8,8.7,8.7,0,0,1,1.8-1.39,9.115,9.115,0,0,1,2.122-.9,8.876,8.876,0,0,1,4.721,0,9.121,9.121,0,0,1,2.122.9,8.872,8.872,0,0,1,3.191,3.192,9.1,9.1,0,0,1,.9,2.128,8.974,8.974,0,0,1-.041,4.9,9.03,9.03,0,0,1-1.013,2.244,8.61,8.61,0,0,1-1.566,1.849,8.74,8.74,0,0,1-2.02,1.349,7.429,7.429,0,0,1-1.113.425q-.577.168-1.17.3v3.081a.486.486,0,0,1-.556.512h-2.295a.456.456,0,0,1-.51-.523v-3.081q-.338-.082-.663-.186t-.628-.233a1.688,1.688,0,0,1-.338-.053,2.3,2.3,0,0,1-.314-.11,8.7,8.7,0,0,1-3.773-3.191,8.809,8.809,0,0,1-1.07-2.3A8.939,8.939,0,0,1,564.222,446.064Zm3.36-.023a5.676,5.676,0,0,0,.424,2.2,5.57,5.57,0,0,0,1.163,1.779,5.509,5.509,0,0,0,1.744,1.2,5.571,5.571,0,0,0,4.349,0,5.587,5.587,0,0,0,1.75-1.2,5.53,5.53,0,0,0,1.168-1.779,5.874,5.874,0,0,0,0-4.383,5.6,5.6,0,0,0-1.168-1.785,5.539,5.539,0,0,0-1.75-1.2,5.571,5.571,0,0,0-4.349,0,5.462,5.462,0,0,0-1.744,1.2,5.683,5.683,0,0,0-1.587,3.97Z",
    transform: "translate(-541.61 -425.21)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "l",
    transform: "matrix(1, 0, 0, 1, -9, -6.52)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M619.064,448.033a5.182,5.182,0,0,0,.279,1.756,3.759,3.759,0,0,0,.785,1.32,3.365,3.365,0,0,0,1.209.825,4.121,4.121,0,0,0,1.564.285,4.168,4.168,0,0,0,1.627-.3,3.336,3.336,0,0,0,1.216-.855,3.772,3.772,0,0,0,.755-1.325,5.29,5.29,0,0,0,.262-1.7V438.29a.492.492,0,0,1,.151-.36.517.517,0,0,1,.382-.151h2.248a.6.6,0,0,1,.412.151.47.47,0,0,1,.168.36v9.871a7.867,7.867,0,0,1-.581,3.145,6.276,6.276,0,0,1-3.868,3.575,8.655,8.655,0,0,1-2.777.442,8.163,8.163,0,0,1-2.777-.471,6.722,6.722,0,0,1-2.3-1.378,6.538,6.538,0,0,1-1.568-2.244,7.639,7.639,0,0,1-.581-3.07V438.29a.54.54,0,0,1,.134-.349.422.422,0,0,1,.343-.163h2.372a.581.581,0,0,1,.36.151.452.452,0,0,1,.186.36Z",
    transform: "translate(-572.43 -425.57)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "matrix(1, 0, 0, 1, -9, -6.52)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M660.357,429.841q0-.558.512-.558h11.209a.506.506,0,0,1,.43.169.686.686,0,0,1,.128.426v2.054a.547.547,0,0,1-.145.374.555.555,0,0,1-.436.163h-8.267v3.523h6.371a.473.473,0,0,1,.372.1.526.526,0,0,1,.14.413v2.1a.625.625,0,0,1-.116.372.426.426,0,0,1-.372.163h-6.395v4.221h8.569a.519.519,0,0,1,.43.14.724.724,0,0,1,.1.432v2.123q0,.491-.512.49h-11.51a.575.575,0,0,1-.361-.116.439.439,0,0,1-.151-.372Zm6.058-5.755a.741.741,0,0,1,.262-.372.631.631,0,0,1,.366-.116h2.07a.331.331,0,0,1,.261.087.316.316,0,0,1,.076.215,1.32,1.32,0,0,1-.018.2.846.846,0,0,1-.064.215l-1.1,2.465a.685.685,0,0,1-.616.488h-1.814q-.2,0-.256-.093a.407.407,0,0,1-.058-.221c0-.077,0-.155.011-.233a.787.787,0,0,1,.07-.244Z",
    transform: "translate(-599.2 -417.07)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "matrix(1, 0, 0, 1, -9, -6.52)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M716.732,438.336q0-.558.512-.558h11.209a.506.506,0,0,1,.43.169.686.686,0,0,1,.128.426v2.054a.547.547,0,0,1-.145.374.555.555,0,0,1-.436.163h-8.267v3.523h6.371a.473.473,0,0,1,.372.1.526.526,0,0,1,.139.413v2.1a.624.624,0,0,1-.116.372.426.426,0,0,1-.372.163h-6.395v4.221h8.569a.519.519,0,0,1,.43.14.724.724,0,0,1,.1.432v2.123q0,.491-.512.49h-11.51a.574.574,0,0,1-.36-.116.439.439,0,0,1-.151-.372Z",
    transform: "translate(-632.97 -425.57)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "matrix(1, 0, 0, 1, -9, -6.52)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M763.533,441.931a.541.541,0,0,1-.279-.075,2.686,2.686,0,0,1-.291-.2l-.023-.012a6.084,6.084,0,0,0-1.348-.988,5.729,5.729,0,0,0-.925-.4,3.2,3.2,0,0,0-1.006-.163,4.142,4.142,0,0,0-1.151.145,2.627,2.627,0,0,0-.837.4,1.713,1.713,0,0,0-.512.587,1.553,1.553,0,0,0-.174.721,1.11,1.11,0,0,0,.262.733,2.407,2.407,0,0,0,.709.558,6.918,6.918,0,0,0,1.029.447q.58.2,1.22.4.733.221,1.453.477a13.378,13.378,0,0,1,1.378.575,9.719,9.719,0,0,1,1.227.71,4.644,4.644,0,0,1,.982.895,4.1,4.1,0,0,1,.651,1.128,3.892,3.892,0,0,1,.238,1.4,5.048,5.048,0,0,1-.512,2.291,5.224,5.224,0,0,1-1.413,1.75,6.483,6.483,0,0,1-2.117,1.116,8.5,8.5,0,0,1-2.61.39,7.692,7.692,0,0,1-1.779-.209,8.6,8.6,0,0,1-1.7-.593,8.984,8.984,0,0,1-1.541-.925,7.669,7.669,0,0,1-1.3-1.215v.012l-.024-.047a.848.848,0,0,1-.256-.535.468.468,0,0,1,.07-.244,1.379,1.379,0,0,1,.21-.256l.384-.384c.116-.1.24-.213.372-.337a5.018,5.018,0,0,1,.4-.337q.2-.151.366-.256a.566.566,0,0,1,.273-.1.494.494,0,0,1,.3.1,2.128,2.128,0,0,1,.232.2l.047.047h-.012a7.714,7.714,0,0,0,.913.733,9.182,9.182,0,0,0,1.04.622,6.245,6.245,0,0,0,1.064.43,3.49,3.49,0,0,0,.994.157,4.25,4.25,0,0,0,1.2-.163,3.1,3.1,0,0,0,.965-.459,2.206,2.206,0,0,0,.639-.715,1.881,1.881,0,0,0,.233-.93,1.335,1.335,0,0,0-.3-.878,2.759,2.759,0,0,0-.791-.64,6.114,6.114,0,0,0-1.1-.471q-.61-.2-1.227-.372a18.493,18.493,0,0,1-2.482-.93,7.542,7.542,0,0,1-1.773-1.122,4.166,4.166,0,0,1-1.064-1.4,4.119,4.119,0,0,1-.354-1.738,4.32,4.32,0,0,1,1.674-3.494,5.971,5.971,0,0,1,1.93-.988,8.4,8.4,0,0,1,2.523-.354,7.374,7.374,0,0,1,2.151.332,8.383,8.383,0,0,1,2.023.913q.279.174.57.4t.535.448a3.151,3.151,0,0,1,.4.441.67.67,0,0,1,.157.367.659.659,0,0,1-.07.285,1.09,1.09,0,0,1-.175.262l-.349.372v-.012l-.36.384a4.6,4.6,0,0,1-.372.355q-.186.157-.337.261A.481.481,0,0,1,763.533,441.931Z",
    transform: "translate(-654.63 -425.12)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(641.907 423.075)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, -120.64, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M549.285,517.139a10.7,10.7,0,0,1-.391,2.919,10.411,10.411,0,0,1-1.116,2.578,10.725,10.725,0,0,1-3.961,3.817,11.229,11.229,0,0,1-2.644,1.05,11.632,11.632,0,0,1-2.941.369h-7.141a.916.916,0,0,1-.464-.116.519.519,0,0,1-.2-.492V507.028a.716.716,0,0,1,.167-.492.632.632,0,0,1,.5-.188h7.141a11.337,11.337,0,0,1,2.933.377A11.115,11.115,0,0,1,543.8,507.8a11.327,11.327,0,0,1,2.238,1.666,10.315,10.315,0,0,1,1.731,2.173,10.917,10.917,0,0,1,1.115,2.593A10.522,10.522,0,0,1,549.285,517.139Zm-13.254-5.591v11.139h1.217q.333,0,.652-.022t.637-.051a5.818,5.818,0,0,0,2.028-.529,5.625,5.625,0,0,0,1.644-1.159,5.216,5.216,0,0,0,1.1-1.688,5.513,5.513,0,0,0,.4-2.115,5.424,5.424,0,0,0-.456-2.238,5.533,5.533,0,0,0-1.238-1.767,5.591,5.591,0,0,0-1.832-1.159,6.064,6.064,0,0,0-2.238-.413Z",
    transform: "translate(-409.78 -497.73)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "matrix(1, 0, 0, 1, -120.64, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M586.692,507.049a.69.69,0,0,1,.166-.485.606.606,0,0,1,.47-.181H601.7a.64.64,0,0,1,.493.188.716.716,0,0,1,.173.505v3.582a.757.757,0,0,1-.173.47.6.6,0,0,1-.507.224H592.3v3.592h7.243a.761.761,0,0,1,.456.13.5.5,0,0,1,.181.435v3.129a.6.6,0,0,1-.159.391.573.573,0,0,1-.464.188H592.3v3.708h9.734a.582.582,0,0,1,.652.664v3.64a.358.358,0,0,1-.116.26q-.058.4-.594.4H587.328a.675.675,0,0,1-.462-.152.594.594,0,0,1-.173-.471Z",
    transform: "translate(-443.41 -497.75)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "matrix(1, 0, 0, 1, -120.64, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M632.376,507.018a.588.588,0,0,1,.2-.462.705.705,0,0,1,.485-.173h15.586a.732.732,0,0,1,.464.159.649.649,0,0,1,.232.476v3.6a.814.814,0,0,1-.181.5.61.61,0,0,1-.515.238h-5v15.861a.69.69,0,0,1-.188.471.628.628,0,0,1-.491.21h-4.248a.681.681,0,0,1-.462-.2.63.63,0,0,1-.216-.486V511.352h-4.983a.675.675,0,0,1-.485-.187.728.728,0,0,1-.2-.549Z",
    transform: "translate(-470.71 -497.75)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(1, 0, 0, 1, -120.64, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M677.518,516.687a11.009,11.009,0,0,1,1.508-5.6,11.221,11.221,0,0,1,1.732-2.253A10.811,10.811,0,0,1,683,507.1a11.361,11.361,0,0,1,2.646-1.115,11.093,11.093,0,0,1,5.892,0,11.338,11.338,0,0,1,2.653,1.115,11,11,0,0,1,3.979,3.984,11.5,11.5,0,0,1,1.116,2.651,11.105,11.105,0,0,1,0,5.9,11.213,11.213,0,0,1-1.116,2.636,10.893,10.893,0,0,1-1.732,2.231,11.332,11.332,0,0,1-2.247,1.731,11.091,11.091,0,0,1-11.19,0,11.231,11.231,0,0,1-3.971-3.962,10.81,10.81,0,0,1-1.116-2.636A10.98,10.98,0,0,1,677.518,516.687Zm5.606-.014a6.15,6.15,0,0,0,.4,2.245,5.54,5.54,0,0,0,1.136,1.818,5.292,5.292,0,0,0,1.729,1.217,5.709,5.709,0,0,0,4.4,0,5.271,5.271,0,0,0,1.736-1.217,5.539,5.539,0,0,0,1.135-1.818,6.4,6.4,0,0,0,0-4.483,5.607,5.607,0,0,0-1.135-1.832,5.4,5.4,0,0,0-7.87,0,5.608,5.608,0,0,0-1.136,1.832A6.168,6.168,0,0,0,683.124,516.672Z",
    transform: "translate(-497.69 -497.27)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, -120.64, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M733.1,527.5q.116-.217.239-.442a5.322,5.322,0,0,1,.283-.456l6.518-9.734q-1.666-2.506-3.3-4.954t-3.3-4.954a1.4,1.4,0,0,1-.138-.217.651.651,0,0,1-.065-.217.141.141,0,0,1,.166-.109.557.557,0,0,0,.282-.065h5.041a.93.93,0,0,1,.84.55l3.549,5.331,3.592-5.331a.93.93,0,0,1,.84-.55h4.824q.159,0,.3.008a.691.691,0,0,1,.239.05.141.141,0,0,1,.1.13.628.628,0,0,1-.159.377l-6.663,9.952L753.086,527a2.591,2.591,0,0,1,.225.369.533.533,0,0,1,.065.282q0,.217-.261.217H747.93a.754.754,0,0,1-.45-.145.981.981,0,0,1-.319-.391l-3.94-5.838-3.9,5.838a.987.987,0,0,1-.319.391.754.754,0,0,1-.449.145h-5.2a.328.328,0,0,1-.2-.065.213.213,0,0,1-.087-.181A.288.288,0,0,1,733.1,527.5Z",
    transform: "translate(-530.89 -497.73)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, -120.64, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M797.081,514.49a8.6,8.6,0,0,1-.037.9,1.159,1.159,0,0,1-.144.5.478.478,0,0,1-.318.21,2.851,2.851,0,0,1-.556.043h-3.38a.591.591,0,0,1-.491-.217.767.767,0,0,1-.174-.492q0-.768.021-1.347t.065-1.014a5.181,5.181,0,0,1,.116-.724,1.725,1.725,0,0,1,.188-.478,4.56,4.56,0,0,1,.917-1.086,8.332,8.332,0,0,1,1.048-.761q.534-.326,1.054-.6a5.227,5.227,0,0,0,.917-.608,2.675,2.675,0,0,0,.643-.789,2.383,2.383,0,0,0,.245-1.137,2.107,2.107,0,0,0-.2-.9,2.618,2.618,0,0,0-.542-.768,2.573,2.573,0,0,0-.794-.529,2.373,2.373,0,0,0-.946-.2,2.249,2.249,0,0,0-.939.2,2.685,2.685,0,0,0-1.343,1.347,2.228,2.228,0,0,0-.2.927v.333a.386.386,0,0,1-.174.355,1.025,1.025,0,0,1-.435.138,3.45,3.45,0,0,1-.558.014c-.2-.009-.374-.014-.529-.014h-2.506a.571.571,0,0,1-.5-.2.686.686,0,0,1-.138-.4v-.478a6.424,6.424,0,0,1,.6-2.788,6.9,6.9,0,0,1,1.606-2.18,7.328,7.328,0,0,1,2.33-1.42,7.682,7.682,0,0,1,2.771-.507,7.386,7.386,0,0,1,2.807.536,7.266,7.266,0,0,1,2.308,1.485,7.253,7.253,0,0,1,1.924,6.873,5.39,5.39,0,0,1-.55,1.34,4.467,4.467,0,0,1-.782.985,8.9,8.9,0,0,1-.9.739q-.456.326-.891.6a5.863,5.863,0,0,0-.775.579,2.726,2.726,0,0,0-.55.666A1.676,1.676,0,0,0,797.081,514.49Zm-5.07,5.316a.659.659,0,0,1,.159-.463.613.613,0,0,1,.477-.174h3.813a.7.7,0,0,1,.455.174.57.57,0,0,1,.21.463v3.505a.711.711,0,0,1-.166.464.607.607,0,0,1-.5.2h-3.813q-.636,0-.636-.666Z",
    transform: "translate(-563.35 -493.83)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueesdetoxMob);
export default __webpack_public_path__ + "static/media/queesdetox_mob.36776a56c4487b5999ee224cdf068f17.svg";
export { ForwardRef as ReactComponent };